import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { profileService } from './profile.service';
import { PaymentService } from '../../payment/payment.service';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../../views/auth/auth.service';
@Component({
    selector   : 'CreateProfile',
    templateUrl: './Profile.component.html',
    styleUrls  : ['./Profile.component.scss']
})
export class CreateProfileComponent implements OnInit, OnDestroy
{  
    form: FormGroup;
    horizontalStepperStep1: FormGroup;
    horizontalStepperStep2: FormGroup;
    horizontalStepperStep3: FormGroup;

    name: string;
    showPopup = false;
    check: any;
    closeResult: string;
    
    public sidebarMinimized = false;
    email$: string;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     *
     * @param {FormBuilder} _formBuilder
     * @param {HttpClient} _httpClient
     */
    constructor(
        private _formBuilder: FormBuilder,private router: Router,private _httpClient: HttpClient, private profileService: profileService

      ,  private payService:PaymentService,private modalService: NgbModal,private authService :AuthService
    )
    {
        this._unsubscribeAll = new Subject();
    }
  
    ngOnInit(): void
    {
        
        this.email$=localStorage.getItem('email')
        this.payService.checkActiveSub(localStorage.getItem("email")).subscribe(
          data =>{
    this.check=data;
    
          },
          error => {
    console.log(error,"error");
    
           }
        );
        this.horizontalStepperStep1 = this._formBuilder.group({
            fullname: ['', Validators.required],
            adresse : ['', Validators.required],
            age: ['', Validators.required],
            Genre : ['', Validators.required],
           
            occupation : ['', Validators.required]

        });

        this.horizontalStepperStep2 = this._formBuilder.group({
            RevenuAnn: ['', Validators.required],
            DepensesMens: ['', Validators.required],
            ObjCourtTerme: ['', Validators.required],
            ObjLongTerme: ['', Validators.required]


        });

        this.horizontalStepperStep3 = this._formBuilder.group({
            ConnaissanceFin : ['', Validators.required],
            SecteurInves  : ['', Validators.required],
            MontantInitInves: ['', Validators.required]
        });
           

      
    }


 
    logout(content):void {
        //27/12/2022
        this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
      }
      
      private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
          return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
          return 'by clicking on a backdrop';
        } else {
          return  `with: ${reason}`;
        }
      }
    
    
      signout():void{
        this.authService.logout(this.email$).subscribe(
          data => {
    
          localStorage.setItem('token', '')
          localStorage.setItem('email','')
          this.router.navigate(['/']);
    
         
    
    
          },
          error => {
            console.log(error, 'error')
            if (error.status == 404) {
             
            }
            else if (error.status == 401) {
              
            }
    
          }
        );
        
    }
    toggleMinimize(e) {
        this.sidebarMinimized = e;
      }
    
    
    
    Gotoprofile(){
    
      this.router.navigate(['/Profile/profile']);
    
    }
    
    GotoprofileSecurity(){
    
      this.router.navigate(['profilesecurity/profilesecurity']);
    
    }
    
    
    GotoSupport(){
    
      this.router.navigate(['support/support']);
    
    }
    
    
    GotoAbonnement(){
    
      this.router.navigate(['accountbilling/accountbilling']);
    
    }
    get formControl1() {
        return this.horizontalStepperStep1.controls;
      }
      get fullname(){
        return this.horizontalStepperStep1.get("fullname")
      }
      get adresse(){
        return this.horizontalStepperStep1.get("adresse")
      }
      get age(){
        return this.horizontalStepperStep1.get("age")
      }
      get Genre(){
        return this.horizontalStepperStep1.get("Genre")
      }
     get occupation(){
      return this.horizontalStepperStep1.get("occupation")
      }



    get formControl2() {
         return this.horizontalStepperStep2.controls;
        }
    get RevenuAnn(){
        return this.horizontalStepperStep2.get("RevenuAnn")
     }
    get DepensesMens(){
        return this.horizontalStepperStep2.get("DepensesMens")
    }
    get ObjCourtTerme(){
        return this.horizontalStepperStep2.get("ObjCourtTerme")
    }
    get ObjLongTerme(){
        return this.horizontalStepperStep2.get("ObjLongTerme")
    }

    
    get formControl3() {
        return this.horizontalStepperStep3.controls;
       }
   get ConnaissanceFin(){
       return this.horizontalStepperStep3.get("ConnaissanceFin")
    }
   get SecteurInves(){
       return this.horizontalStepperStep3.get("SecteurInves")
   }
   get MontantInitInves(){
       return this.horizontalStepperStep3.get("MontantInitInves")
   }
   
    
    ngOnDestroy(): void
    {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    finishHorizontalStepper(): void {
       
        const email = localStorage.getItem('email'); 

        const profile = {
          email:email,
          fullname: this.formControl1.fullname.value,
          adresse: this.formControl1.adresse.value,
          age: this.formControl1.age.value,
          Genre: this.formControl1.Genre.value,
          occupation: this.formControl1.occupation.value,
          RevenuAnn: this.formControl2.RevenuAnn.value,
          DepensesMens: this.formControl2.DepensesMens.value,
          ObjCourtTerme: this.formControl2.ObjCourtTerme.value,
          ObjLongTerme: this.formControl2.ObjLongTerme.value,
          ConnaissanceFin: this.formControl3.ConnaissanceFin.value,
          SecteurInves: this.formControl3.SecteurInves.value,
          MontantInitInves: this.formControl3.MontantInitInves.value
        };    

        
        this.profileService.AddProfile(profile).subscribe(
            data =>{
                this.router.navigate(['/Dashboard']);
        console.log ("adazdazdazdaz");

            },
            error => {
        console.log(error,"error");
        
             }
          );
}
}